/* smelo shop (flavors, product page, mix builder, favorites, search) */

(function(){
  /* Settings: adjust prices and discounts here */
  var S=window.SMELO, FL=S.flavors||[], FREE_SHIP=S.freeShip, TIERS=S.tiers||[[3,5],[5,10]];
  var PRICE=FL.length?FL[0].price:8.95, PACKS={1:0};
  TIERS.forEach(function(t){PACKS[t[0]]=t[1]/100});
  var T=function(sec,k,d){var o=(S.t&&S.t[sec])||{};return (o[k]!=null&&o[k]!=='')?o[k]:d};
  var fmt=function(str,o){return String(str).replace(/\{(\w+)\}/g,function(_,k){return o[k]!=null?o[k]:''})};
  var A=function(n){return (S.assets&&S.assets[n])||n};
  var tinsW=function(sec,n){return n===1?T(sec,'one_tin','tin'):T(sec,'many_tins','tins')};
  var tierDisc=function(n){var d=0;TIERS.forEach(function(t){if(n>=t[0])d=t[1]/100});return d};
  var nextTier=function(n){for(var i=0;i<TIERS.length;i++)if(n<TIERS[i][0])return TIERS[i];return null};
  var one=function(id){var o={};o[id]=1;return o};
  var eur=function(n){return new Intl.NumberFormat('en-IE',{style:'currency',currency:S.currency||'EUR'}).format(n)};
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var fById=function(id){return FL.filter(function(f){return f.id===id})[0]};
  if(!FL.length)return;
  var P={
    bolt:'<path d="M13 2 4 14h7l-1 8 9-12h-7z"/>',
    drop:'<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>',
    target:'<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.2"/>',
    leaf:'<path d="M5 19C5 10 10 5 20 5c0 10-5 15-13 15"/><path d="M5 19c2-5 5-8 9-10"/>',
    search:'<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/>',
    user:'<circle cx="12" cy="8" r="4"/><path d="M4 20c1-4 4.5-6 8-6s7 2 8 6"/>',
    bag:'<path d="M6 8h12l1 12H5z"/><path d="M9 8a3 3 0 0 1 6 0"/>',
    box:'<path d="M12 3 4 7v10l8 4 8-4V7z"/><path d="M4 7l8 4 8-4M12 11v10"/>',
    check:'<path d="m5 12.5 4.5 4.5L19 7.5"/>'
  };
  var icon=function(n){return '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true">'+P[n]+'</svg>'};
  var ph=function(f,cls){return '<img'+(cls?' class="'+cls+'"':'')+' src="'+f.img+'" alt="" width="190" height="190" loading="lazy">'};

  Array.prototype.forEach.call(document.querySelectorAll('.freeAmt'),function(e){e.textContent=eur(FREE_SHIP)});
  if($('#strip'))$('#strip').innerHTML=[['box','20 pouches per tin'],['leaf','Natural flavors'],['drop','Electrolytes'],['bolt','B vitamins'],['check','Nicotine-free']]
    .map(function(a){return '<div>'+icon(a[0])+'<span>'+a[1]+'</span></div>'}).join('');

  /* smaken */
  $('#flavs').innerHTML=FL.map(function(f){
    return '<article class="fcard" data-name="'+f.name+'" data-id="'+f.id+'"><div class="art">'+(T('flavors','badge','New')?'<span class="ftag"><i class="bdot" aria-hidden="true"></i>'+T('flavors','badge','New')+'</span>':'')+(T('flavors','pill','20 pouches')?'<span class="fpill">'+T('flavors','pill','20 pouches')+'</span>':'')+'<button type="button" class="fadd" data-add="'+f.id+'" aria-label="'+fmt(T('flavors','add_label','Add {name} to cart'),{name:f.name})+'"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.5 8h13l1 11.2a2 2 0 0 1-2 2.2H6.5a2 2 0 0 1-2-2.2z"/><path d="M8.5 10.5V7a3.5 3.5 0 0 1 7 0v3.5"/><path d="M12 13v5M9.5 15.5h5"/></svg></button><img src="'+f.img+'" alt="smelo '+f.name+'" width="195" height="190" loading="lazy"><button type="button" class="heart" data-fav="'+f.id+'" aria-pressed="false" aria-label="Favorite: '+f.name+'"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg></button></div>'+
      '<h3><i class="dot" style="background:'+f.c+'"></i><a class="flink" href="/#product/'+f.id+'">'+f.name+'</a></h3><p class="pr">'+f.line+'</p>'+
      '<p class="pp">'+eur(f.price)+'</p></article>';
  }).join('');
  $('#flavs').addEventListener('click',function(e){
    var b=e.target.closest('[data-add]'); if(!b) return;
    SmeloCart.addFlavors(one(b.getAttribute('data-add')));
  });

  /* product */
  var cur=0, pq=1, psize=1, pv=0;
  var sizeKeys=Object.keys(PACKS);
  var sizePrice=function(n){return n*PRICE*(1-PACKS[n])};
      var ppicks={}; FL.forEach(function(f){ppicks[f.id]=0});
  var pTotal=function(){return FL.reduce(function(a,f){return a+ppicks[f.id]},0)};
  var pDisc=tierDisc;
  function resetPicks(){FL.forEach(function(f){ppicks[f.id]=0});ppicks[FL[cur].id]=1}
  $('#swatches').innerHTML=FL.map(function(f,i){return '<div class="sw2w"><button class="sw2" data-i="'+i+'" aria-pressed="false" aria-label="View '+f.name+'"><span class="sw2-i"><img src="'+f.img+'" alt="" width="52" height="52" loading="lazy"></span><span class="sw2-n">'+f.name+'</span></button><div class="sw2-st" role="group" aria-label="'+f.name+' quantity"><button type="button" data-pf="'+f.id+'" data-d="-1" aria-label="Less '+f.name+'">\u2212</button><output id="pq-'+f.id+'">0</output><button type="button" data-pf="'+f.id+'" data-d="1" aria-label="More '+f.name+'">+</button></div></div>'}).join('');
  
  var GAL=function(f){var X={'berry-ice':[A('when-berry.jpg'),A('howto.jpg')],watermelon:[A('when-watermelon.jpg'),A('howto-watermelon.jpg')],citrus:[A('howto-citrus.jpg'),A('when-citrus.jpg')],grape:[A('howto-grape.jpg'),A('when-grape.jpg')]}[f.id]||[A('open.jpg'),A('life1.jpg')];return (f.gallery&&f.gallery.length>=2)?[f.img,f.gallery[0],f.gallery[1]]:[f.img,X[0],X[1]]};
  $('#gal').innerHTML=[1,2].map(function(i){return '<button data-v="'+i+'" aria-pressed="false" aria-label="Foto '+(i+1)+'"><img id="g'+i+'" alt="" width="190" height="190"></button>'}).join('');
  function renderProduct(){
    var f=FL[cur], g=GAL(f), im=$('#pImg');
    im.src=g[pv]; im.alt=pv===0?'smelo '+f.name+' electrolyte pouches':(/when-/.test(g[pv])?'When to use smelo: workout, morning ritual, night out, on the job':(/howto/.test(g[pv])?'How to use smelo: place a pouch between lip and gum, sip some water, enjoy':(g[pv]===A('open.jpg')?'Open tin with white pouches':'smelo in everyday life')));
    var tl=$('#pTile');if(tl){var TL={watermelon:[A('watermelon-fresh.jpg'),'Fresh watermelon slices with water drops'],citrus:[A('citrus-fresh.jpg'),'Fresh lemons and oranges with water drops'],'berry-ice':[A('strawberry-fresh.jpg'),'Fresh strawberries with water drops'],grape:[A('grape-fresh.jpg'),'Fresh grapes with water drops']}[f.id]||[f.img,'smelo '+f.name+' electrolyte pouches'];tl.src=TL[0];tl.alt=TL[1]}
    g.forEach(function(src,i){var el=$('#g'+i);if(el)el.src=src});
    $$('#gal button').forEach(function(b){b.setAttribute('aria-pressed',+b.getAttribute('data-v')===pv)});
    $('#pName').textContent=f.name; $('#crumb').textContent=f.name;
    var d=fmt(T('pdp','desc','smelo {name}: {line} Electrolyte pouches for more energy, focus and balance, wherever you are.'),{name:f.name,line:(f.line||'').toLowerCase()});
    $('#pDesc').textContent=d;
    $$('.sw2').forEach(function(b,i){b.setAttribute('aria-pressed',i===cur)});
    
    var t=pTotal(), d2=pDisc(t), full=FL.reduce(function(a,x){return a+ppicks[x.id]*x.price},0), tot=full*(1-d2);
    FL.forEach(function(x){var o=$('#pq-'+x.id);if(o)o.textContent=ppicks[x.id];var bs=$$('[data-pf="'+x.id+'"]');if(bs.length){bs[0].disabled=ppicks[x.id]===0;bs[1].disabled=t>=20}});
    $('#pMixT').textContent=t+' '+tinsW('pdp',t)+' '+T('pdp','in_mix','in your mix');
    var nt=nextTier(t),hint=t===0?T('pdp','hint_none','Pick at least 1 tin.'):(nt?fmt(T('pdp','hint_more','Add {need} more {tins} for {pct}% off'),{need:nt[0]-t,tins:tinsW('pdp',nt[0]-t),pct:nt[1]}):fmt(T('pdp','hint_max','{pct}% mix discount applied'),{pct:TIERS[TIERS.length-1][1]}));
    $('#pSizeTxt').textContent=hint;
    $('#pPrice').innerHTML=(d2?'<s class="was">'+eur(full)+'</s> ':'')+eur(tot);
    $('#pAdd').disabled=t===0;
    var sub=T('pdp','add_sub','');$('#pAdd').innerHTML=t?(T('pdp','add_label','Add to cart')+' \u00b7 '+eur(tot)+(sub?'<small class="po">'+sub+'</small>':'')):T('pdp','choose_label','Choose your tins');
    $('#pinfo').style.setProperty('--flv',f.c);
  }
  function setUrl(id){try{history.replaceState(null,'',location.pathname+location.search+'#product/'+id)}catch(e){}}
  $('#swatches').addEventListener('click',function(e){var b=e.target.closest('.sw2');if(!b)return;cur=+b.getAttribute('data-i');pv=0;if(pTotal()===0)ppicks[FL[cur].id]=1;setUrl(FL[cur].id);renderProduct()});
  $('#swatches').addEventListener('click',function(e){var b=e.target.closest('[data-pf]');if(!b||b.disabled)return;var id=b.getAttribute('data-pf'),d=+b.getAttribute('data-d');if(d>0&&pTotal()>=20)return;ppicks[id]=Math.max(0,ppicks[id]+d);renderProduct()});
  
  $('#gal').addEventListener('click',function(e){var b=e.target.closest('[data-v]');if(!b)return;var v=+b.getAttribute('data-v');pv=pv===v?0:v;renderProduct();window.scrollTo({top:0,behavior:'smooth'})});
  
  
  $('#pAdd').onclick=function(){var t=pTotal();if(!t)return;SmeloCart.addFlavors(JSON.parse(JSON.stringify(ppicks)))};
  /* routing: #product/<flavor> shows the product page */
  var rootEl=document.documentElement;
  function route(){
    var h=location.hash, m=h.match(/^#product(?:\/([\w-]+))?$/);
    var wasC=rootEl.classList.contains('cpage'), isC=(h==='#contact'||h==='#ctForm'||h==='#contact_form'||h==='#track'||h==='#spForm'||h==='#ppForm');
    if(isC){rootEl.setAttribute('data-v',(h==='#track'||h==='#spForm')?'track':'contact');rootEl.classList.remove('pdp');rootEl.classList.add('cpage');window.scrollTo(0,0);try{window.SmeloCart&&SmeloCart.close()}catch(e){}return}
    if(wasC){rootEl.classList.remove('cpage');if(!m){var t0=h.length>1?document.getElementById(h.slice(1)):null;requestAnimationFrame(function(){if(t0)t0.scrollIntoView();else window.scrollTo(0,0)});return}}
    if(m){
      if(m[1]){var i=FL.map(function(f){return f.id}).indexOf(m[1]);if(i>-1&&(i!==cur||!rootEl.classList.contains('pdp'))){cur=i;pv=0;psize=1;pq=1;resetPicks()}}
      if(pTotal()===0)resetPicks();renderProduct();rootEl.classList.add('pdp');window.scrollTo(0,0);
    }else if(rootEl.classList.contains('pdp')){
      rootEl.classList.remove('pdp');
      var t=h.length>1?document.getElementById(h.slice(1)):null;
      requestAnimationFrame(function(){if(t)t.scrollIntoView();else window.scrollTo(0,0)});
    }
  }
  addEventListener('hashchange',route);
  $('#flavs').addEventListener('click',function(e){
    if(e.target.closest('[data-add],[data-fav],a'))return;
    var c=e.target.closest('.fcard');if(c)location.hash='#product/'+c.getAttribute('data-id');
  });
  (function(){var st=S.start,h0=location.hash;if(st&&(!h0||h0==='#')){try{history.replaceState(null,'',location.pathname+location.search+(st==='contact'?'#contact':'#product/'+st.split(':')[1]))}catch(e){}}})();
  renderProduct();route();

  /* mix & match */
  var picks={}, MAXMIX=20;
  var discFor=tierDisc;
  FL.forEach(function(f){picks[f.id]=0});
  var total=function(){return FL.reduce(function(s,f){return s+picks[f.id]},0)};
  $('#brows').innerHTML=FL.map(function(f){
    return '<div class="brow"><div class="th">'+ph(f,'timg')+'</div><div class="nm"><b>'+f.name+'</b><span>'+f.line+' \u00b7 '+eur(f.price)+'</span></div>'+
      '<div class="step"><button data-f="'+f.id+'" data-d="-1" aria-label="Less '+f.name+'">\u2212</button><output id="q-'+f.id+'">0</output><button data-f="'+f.id+'" data-d="1" aria-label="More '+f.name+'">+</button></div></div>';
  }).join('');
  function updateBuilder(){
    var t=total(), disc=discFor(t), full=FL.reduce(function(a,x){return a+picks[x.id]*x.price},0), price=full*(1-disc);
    FL.forEach(function(f){
      $('#q-'+f.id).textContent=picks[f.id];
      var b=$$('[data-f="'+f.id+'"]');
      b[0].disabled=picks[f.id]===0; b[1].disabled=t>=MAXMIX;
    });
    var chosen=[];
    FL.forEach(function(f){for(var i=0;i<picks[f.id];i++)chosen.push(f)});
    var s='',n=Math.max(chosen.length,3);
    for(var i=0;i<n;i++) s+=chosen[i]?'<div class="slot on">'+ph(chosen[i])+'</div>':'<div class="slot" aria-hidden="true"></div>';
    $('#slots').innerHTML=s;
    $('#bBar').style.width=Math.min(t/(TIERS[TIERS.length-1][0]),1)*100+'%';
    var nt=nextTier(t),hint;
    if(t===0)hint=T('mix','hint_none','Pick as many tins as you like.');
    else if(nt)hint=fmt(T('mix','hint_more','Add {need} more {tins} for {pct}% off.'),{need:nt[0]-t,tins:tinsW('mix',nt[0]-t),pct:nt[1]});
    else hint=fmt(T('mix','hint_max','You get the best mix discount: {pct}% off.'),{pct:TIERS[TIERS.length-1][1]});
    $('#bHint').textContent=hint;
    $('#bFull').textContent=eur(full);
    $('#bDiscLbl').textContent=disc?fmt(T('mix','disc_label','{pct}% mix discount'),{pct:Math.round(disc*100)}):T('mix','nodisc_label','No mix discount');
    $('#bSave').textContent='\u2212 '+eur(full-price);
    $('#bTotal').textContent=eur(price);
    var bb=$('#bBuy');if(bb)bb.disabled=t===0; var a=$('#bAdd'); a.disabled=t===0; var s1=T('mix','add_sub','');a.innerHTML=t?fmt(T('mix','add_label','Add {n} {tins} to cart'),{n:t,tins:tinsW('mix',t)})+(s1?'<small class="po">'+s1+'</small>':''):T('mix','choose_label','Choose your tins');if(bb&&bb.getAttribute('data-sub')===null){bb.setAttribute('data-sub',bb.textContent.trim());var s2=T('mix','buy_sub','');bb.innerHTML=bb.getAttribute('data-sub')+(s2?'<small class="po">'+s2+'</small>':'')}
  }
  $('#brows').addEventListener('click',function(e){
    var b=e.target.closest('[data-f]');if(!b||b.disabled)return;
    var id=b.getAttribute('data-f'),d=+b.getAttribute('data-d');
    if(d>0&&total()>=MAXMIX)return; if(d<0&&picks[id]===0)return;
    picks[id]+=d;updateBuilder();
  });
  function addMix(){var t=total();if(!t)return false;SmeloCart.addFlavors(JSON.parse(JSON.stringify(picks)));FL.forEach(function(f){picks[f.id]=0});updateBuilder();return true}
  $('#bAdd').onclick=addMix;
  if($('#bBuy'))$('#bBuy').onclick=function(){var t=total();if(!t)return;var p=JSON.parse(JSON.stringify(picks));SmeloCart.addFlavors(p,{checkout:true})};
  updateBuilder();

  /* favorieten */
  var favs=[];
  try{favs=JSON.parse(localStorage.getItem('smelo-fav-v2')||'[]')}catch(e){favs=[]}
  favs=(Array.isArray(favs)?favs:[]).filter(function(id,i,a){return fById(id)&&a.indexOf(id)===i});
  function saveFav(){try{localStorage.setItem('smelo-fav-v2',JSON.stringify(favs))}catch(e){}}
  function renderFav(){
    $$('[data-fav]').forEach(function(b){var on=favs.indexOf(b.getAttribute('data-fav'))>-1;b.setAttribute('aria-pressed',on);b.classList.toggle('on',on)});
    var n=$('#favN');n.textContent=favs.length;n.hidden=!favs.length;
    $('#favPop').innerHTML='<h3 class="fp-t">Favorites</h3>'+(favs.length?favs.map(function(id){var f=fById(id);
      return '<div class="fp-row"><img src="'+f.img+'" alt="" width="44" height="44"><div class="fp-nm"><b>'+f.name+'</b><span>'+eur(f.price)+'</span></div><button type="button" class="fp-add" data-fadd="'+id+'">'+T('pdp','add_label','Add to cart')+'</button><button type="button" class="fp-rm" data-frm="'+id+'" aria-label="Remove '+f.name+' from favorites">\u00d7</button></div>'}).join(''):'<p class="fp-empty">No favorites yet. Tap the heart on a flavor to save it here.</p>');
  }
  $('#flavs').addEventListener('click',function(e){
    var b=e.target.closest('[data-fav]');if(!b)return;
    var id=b.getAttribute('data-fav'),i=favs.indexOf(id);
    if(i>-1)favs.splice(i,1);else favs.push(id);
    saveFav();renderFav();
  });
  $('#favPop').addEventListener('click',function(e){
    e.stopPropagation();
    var a=e.target.closest('[data-fadd]'),r=e.target.closest('[data-frm]');
    if(a){$('#favPop').hidden=true;$('#openFav').setAttribute('aria-expanded','false');SmeloCart.addFlavors(one(a.getAttribute('data-fadd')))}
    if(r){var i=favs.indexOf(r.getAttribute('data-frm'));if(i>-1)favs.splice(i,1);saveFav();renderFav()}
  });
  renderFav();

  (function(){var f=document.querySelector('.site-footer .pay');var pp=$('#ppay');if(f&&pp&&!pp.children.length)pp.innerHTML=f.innerHTML})();

    

    /* header: zoeken, account, actieve menulink */
  var sb=$('#searchbar'), sq=$('#sq'), pop={hidden:true};
  function filterFlavs(){
    var v=sq.value.trim().toLowerCase(), shown=0;
    $$('.fcard').forEach(function(c){var m=!v||c.getAttribute('data-name').toLowerCase().indexOf(v)>-1;c.hidden=!m;if(m)shown++});
    $('#noMatch').hidden=shown>0;
  }
  function closeSearch(){if(sb.hidden)return;sb.hidden=true;sq.value='';filterFlavs();$('#openSearch').setAttribute('aria-expanded','false')}
  function closeAcc(){}
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeSearch()}});
  $('#openSearch').onclick=function(){
    if(!sb.hidden){closeSearch();return}
    closeAcc();sb.hidden=false;$('#openSearch').setAttribute('aria-expanded','true');sq.focus();
  };
  sq.addEventListener('input',function(){filterFlavs();if(sq.value){var sm=$('#smaken');if(sm)sm.scrollIntoView()}});
  
  
  var links={};
  $$('nav.main a').forEach(function(a){links[a.getAttribute('href').replace(/^.*#/,'')]=a});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(!e.isIntersecting)return;
      Object.keys(links).forEach(function(k){links[k].removeAttribute('aria-current')});
      if(links[e.target.id])links[e.target.id].setAttribute('aria-current','true');
    })},{rootMargin:'-35% 0px -55% 0px'});
    Object.keys(links).forEach(function(k){var el=document.getElementById(k);if(el)io.observe(el)});
  }
})();


/* lekkende waterdruppels achter de blokken */
(function(){
  var wb=document.querySelector('.wb'),cv=wb&&wb.querySelector('.wb-drops');
  if(!cv||!cv.getContext)return;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  var ctx=cv.getContext('2d'),W=0,H=0,dpr=1,drops=[],raf=0,vis=false,last=0;
  function mk(top){var r=2.5+Math.random()*4.5;return{x:Math.random()*W,y:top?-20-Math.random()*H*.3:Math.random()*H,r:r,v:0,t:0,go:Math.random()*2,hist:[],life:0}}
  function size(){
    dpr=Math.min(window.devicePixelRatio||1,2);W=wb.clientWidth;H=wb.clientHeight;
    cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);ctx.setTransform(dpr,0,0,dpr,0,0);
    var n=Math.max(6,Math.min(26,Math.round(W*H/38000)));
    while(drops.length<n)drops.push(mk(false));drops.length=n;
  }
  function draw(d){
    var h=d.hist;
    if(h.length>1){
      var g=ctx.createLinearGradient(0,h[0].y,0,d.y);
      g.addColorStop(0,'rgba(255,255,255,0)');g.addColorStop(1,'rgba(255,255,255,.5)');
      ctx.strokeStyle=g;ctx.lineCap='round';ctx.lineWidth=Math.max(1.4,d.r*.55);
      ctx.beginPath();ctx.moveTo(h[0].x,h[0].y);for(var i=1;i<h.length;i++)ctx.lineTo(h[i].x,h[i].y);ctx.lineTo(d.x,d.y);ctx.stroke();
      ctx.strokeStyle='rgba(176,10,70,.16)';ctx.lineWidth=1;ctx.beginPath();ctx.moveTo(h[0].x+d.r*.5,h[0].y);for(i=1;i<h.length;i++)ctx.lineTo(h[i].x+d.r*.5,h[i].y);ctx.stroke();
    }
    var rg=ctx.createRadialGradient(d.x-d.r*.35,d.y-d.r*.4,d.r*.1,d.x,d.y,d.r*1.15);
    rg.addColorStop(0,'rgba(255,255,255,.95)');rg.addColorStop(.35,'rgba(255,205,222,.55)');rg.addColorStop(1,'rgba(200,20,80,.38)');
    ctx.fillStyle=rg;ctx.beginPath();ctx.ellipse(d.x,d.y,d.r*.85,d.r*1.1,0,0,6.2832);ctx.fill();
    ctx.fillStyle='rgba(255,255,255,.9)';ctx.beginPath();ctx.arc(d.x-d.r*.3,d.y-d.r*.4,d.r*.22,0,6.2832);ctx.fill();
  }
  function tick(ts){
    raf=0;if(!vis)return;
    var dt=Math.min((ts-last)/1000||.016,.05);last=ts;
    ctx.clearRect(0,0,W,H);
    for(var i=0;i<drops.length;i++){
      var d=drops[i];d.t+=dt;
      if(d.t>d.go){ /* stick-slip: plakken en dan wegglijden */
        d.v+=(90+d.r*28)*dt;if(d.v>260+d.r*30)d.v=260+d.r*30;
        if(Math.random()<dt*.6){d.go=d.t+.4+Math.random()*1.6;d.v*=.15}
      }else d.v*=.9;
      d.y+=d.v*dt;d.x+=Math.sin(d.y*.02+i)*.12;
      if(d.v>8){d.hist.push({x:d.x,y:d.y});if(d.hist.length>26)d.hist.shift()}
      else if(d.hist.length)d.hist.shift();
      draw(d);
      if(d.y-d.r>H+10){drops[i]=mk(true)}
    }
    raf=requestAnimationFrame(tick);
  }
  function start(){if(!raf&&vis&&!reduce){last=performance.now();raf=requestAnimationFrame(tick)}}
  size();
  if(reduce){drops.forEach(function(d){d.hist=[];draw(d)});}
  if('ResizeObserver' in window)new ResizeObserver(function(){size()}).observe(wb);else window.addEventListener('resize',size);
  if('IntersectionObserver' in window)new IntersectionObserver(function(e){vis=e[0].isIntersecting;if(vis)start()},{rootMargin:'100px'}).observe(wb);else{vis=true;start()}
})();


/* fav popup, flavor scroller, reviews, mobile search */
(function(){
  var b=document.getElementById("openFav"),p=document.getElementById("favPop");
  if(b&&p){function c(){p.hidden=true;b.setAttribute("aria-expanded","false")}
    b.addEventListener("click",function(e){e.stopPropagation();var o=p.hidden;p.hidden=!o;b.setAttribute("aria-expanded",String(o))});
    document.addEventListener("click",function(e){if(!p.contains(e.target))c()});
    document.addEventListener("keydown",function(e){if(e.key==="Escape")c()})}
  var f=document.getElementById("flavs"),pr=document.getElementById("flPrev"),nx=document.getElementById("flNext");
  if(f&&pr&&nx){var st=function(d){var c=f.firstElementChild;if(c)f.scrollBy({left:d*(c.offsetWidth+17),behavior:"smooth"})};pr.onclick=function(){st(-1)};nx.onclick=function(){st(1)}}
  var tr=document.getElementById("revTrack"),rp=document.getElementById("revPrev"),rn=document.getElementById("revNext");
  if(tr&&rp&&rn&&tr.firstElementChild){var rs=function(d){tr.scrollBy({left:d*(tr.firstElementChild.offsetWidth+16),behavior:"smooth"})};rp.onclick=function(){rs(-1)};rn.onclick=function(){rs(1)}}
  var h=document.querySelector('header.top'),ms=document.getElementById('mSearch'),os=document.getElementById('openSearch');
  if(h&&ms&&os)ms.addEventListener('click',function(){h.classList.remove('menu-open');os.click()});
  if(window.Shopify&&Shopify.designMode)document.addEventListener('shopify:section:load',function(){location.reload()});
})();
(function(){var b=document.querySelector('.pb-badge[data-cycle]');if(!b)return;var s=b.querySelectorAll('.pbs');if(s.length<2||window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;var i=0;setInterval(function(){s[i].classList.remove('is-on');i=(i+1)%s.length;s[i].classList.add('is-on')},3600)})();

(function(){
  var d=document,de=d.documentElement,rm=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  function q(s,r){return (r||d).querySelector(s)}function qa(s,r){return [].slice.call((r||d).querySelectorAll(s))}
  /* scroll reveal */
  if('IntersectionObserver' in window&&!rm){
    de.classList.add('js-rv');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    var seen=[];function reg(){qa('.sec-head,.mix-head,.fcard,#mix .brow,#mix .bsum,.rev-in,.lifex>*,.about>*,.faq,.fm>*,.pb-tile,.pb-how').forEach(function(el){if(seen.indexOf(el)>-1)return;seen.push(el);var p=el.parentNode;el.style.setProperty('--i',Math.min([].indexOf.call(p.children,el),5));el.classList.add('rv');io.observe(el)})}
    reg();setTimeout(reg,1200);
  }
  /* header shadow + hero parallax */
  var top=q('.top'),py=q('.phb-img img'),tick=false;
  function onS(){tick=false;var y=window.pageYOffset||0;if(top)top.classList.toggle('scrolled',y>10);if(py&&!rm&&y<900)py.style.setProperty('--py',(y*.07).toFixed(1)+'px')}
  window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(onS)}},{passive:true});onS();
  /* mix & match: selected cards, pop, unlock glow */
  var br=q('#brows'),sl=q('#slots'),sum=q('#mix .bsum'),lbl=q('#bDiscLbl');
  function sync(){qa('.brow',br).forEach(function(r){var o=q('output',r),n=o?+o.textContent:0;r.classList.toggle('has',n>0);r.setAttribute('data-n',n)})}
  if(br){sync();new MutationObserver(sync).observe(br,{subtree:true,childList:true,characterData:true})}
  if(sl){var prev=0;new MutationObserver(function(){var on=qa('.slot.on',sl);if(on.length>prev&&!rm){on[on.length-1].classList.add('slot-pop')}prev=on.length}).observe(sl,{childList:true})}
  if(lbl&&sum){var last=lbl.textContent;new MutationObserver(function(){var t=lbl.textContent;if(t!==last&&/\d+%/.test(t)&&!rm){sum.classList.remove('unlock');void sum.offsetWidth;sum.classList.add('unlock')}last=t}).observe(lbl,{childList:true,characterData:true,subtree:true})}
})();


(function(){
  if(!('IntersectionObserver' in window)||(window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches))return;
  var els=[].slice.call(document.querySelectorAll('.life .lifex>h2,.life .lifex>.copy,.life .lv'));
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.15});
  els.forEach(function(el,i){if(el.classList.contains('rv'))return;el.style.setProperty('--i',el.classList.contains('lv')?[].indexOf.call(el.parentNode.children,el):0);el.classList.add('rv');io.observe(el)});
})();


(function(){
  var tr=document.getElementById('revTrack');
  if(!tr||!tr.firstElementChild||tr.parentNode.classList.contains('rev-mask'))return;
  var mask=document.createElement('div');mask.className='rev-mask';tr.parentNode.insertBefore(mask,tr);mask.appendChild(tr);
  var orig=[].slice.call(tr.children);
  function build(){
    [].slice.call(tr.querySelectorAll('[data-clone]')).forEach(function(n){n.remove()});
    var cw=orig[0].offsetWidth+16||260,setW=cw*orig.length,need=Math.ceil(mask.clientWidth*1.2/setW),reps=Math.max(1,need);
    /* sets of identical halves: half = orig repeated reps times */
    for(var h=0;h<2;h++)for(var r=0;r<reps;r++)orig.forEach(function(el,i){if(h===0&&r===0)return;var c=el.cloneNode(true);c.setAttribute('data-clone','1');c.setAttribute('aria-hidden','true');tr.appendChild(c)});
    tr.style.setProperty('--d',Math.max(20,Math.round(setW*reps/55))+'s');
  }
  build();var t;window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(build,250)});
})();


(function(){var f=document.getElementById('tkForm');if(!f)return;f.addEventListener('submit',function(e){var n=document.getElementById('tkNo'),m=document.getElementById('tkMail'),t=document.getElementById('tkNote');
if(!n.value.trim()||!m.value.trim()||m.value.indexOf('@')<1){e.preventDefault();t.textContent='Please fill in your order number and email address.'}})})();



(function(){
  var tl=document.getElementById('tkTl');if(!tl)return;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  var boxes=[].slice.call(tl.querySelectorAll('.tk-box')).map(function(b){
    var base=b.querySelector('.tk-base'),mask=b.querySelector('.tk-mask'),pc=b.querySelector('.tk-pc');
    return{b:b,st:[].slice.call(b.querySelectorAll('.tk-st')),base:base,mask:mask,pc:pc,len:base.getTotalLength(),at:0}
  });
  var n=boxes[0].st.length,i=-1;
  function place(o,f){var pt=o.base.getPointAtLength(o.len*f);o.pc.setAttribute('cx',pt.x);o.pc.setAttribute('cy',pt.y)}
  function glide(o,to){var from=o.at,t0=null,d=900;function f(t){if(!t0)t0=t;var k=Math.min(1,(t-t0)/d),e=k<.5?2*k*k:1-Math.pow(-2*k+2,2)/2;o.at=from+(to-from)*e;place(o,o.at);if(k<1)requestAnimationFrame(f)}requestAnimationFrame(f)}
  function show(k){boxes.forEach(function(o){
    o.st.forEach(function(s,j){s.classList.toggle('done',j<k);s.classList.toggle('now',j===k)});
    var p=Math.max(0,k)/(n-1);o.mask.style.strokeDashoffset=String(1-p);
    if(rm){o.at=p;place(o,p)}else glide(o,p)})}
  if(rm){boxes.forEach(function(o){o.st.forEach(function(s){s.classList.add('done')});o.mask.style.strokeDashoffset='0';place(o,1)});return}
  boxes.forEach(function(o){place(o,0)});
  function tick(){
    if(!tl.offsetParent)return;
    i++;
    if(i>n){i=-1;boxes.forEach(function(o){o.st.forEach(function(s){s.classList.remove('done','now')});o.mask.style.strokeDashoffset='1';o.at=0;place(o,0)});return}
    if(i===n){boxes.forEach(function(o){o.st.forEach(function(s){s.classList.add('done');s.classList.remove('now')})});return}
    show(i);
  }
  tick();setInterval(tick,1800);
})();


(function(){
  var h=document.querySelector('header.top'),b=document.getElementById('burger');if(!h||!b)return;
  function close(){h.classList.remove('menu-open');b.setAttribute('aria-expanded','false')}
  var s=h.querySelector('.mm-search');if(s)s.addEventListener('click',function(){close();var o=document.getElementById('openSearch');if(o)o.click()});
  var c=h.querySelector('.mm-cta');if(c)c.addEventListener('click',close);
})();


(function(){
  var fm=document.querySelector('.fm');if(!fm)return;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  var items=[].slice.call(fm.querySelectorAll('.fm-i'));
  /* one open at a time */
  items.forEach(function(d){d.addEventListener('toggle',function(){if(d.open)items.forEach(function(o){if(o!==d)o.open=false})})});
  if(items[0]&&!items[0].hasAttribute('open')&&!rm)items[0].open=true;
  /* reveal + count up */
  if(!('IntersectionObserver' in window)||rm)return;
  var targets=[].slice.call(fm.querySelectorAll('.fm-stats div,.fm-i,.fm-sub,.fm-note'));
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);var b=e.target.querySelector&&e.target.querySelector('.fm-stats b, b');if(e.target.parentNode&&e.target.parentNode.classList.contains('fm-stats'))count(e.target.querySelector('b'))}})},{threshold:.2});
  targets.forEach(function(el){if(!el.classList.contains('rv')){var p=el.parentNode;el.style.setProperty('--i',Math.min([].indexOf.call(p.children,el),5));el.classList.add('rv')}io.observe(el)});
  function count(b){if(!b)return;var t=b.textContent.trim(),n=parseInt(t,10);if(isNaN(n)||String(n)!==t)return;if(n===0){b.classList.add('fm-pop');return}
    var t0=null,d=1100;function f(ts){if(!t0)t0=ts;var k=Math.min(1,(ts-t0)/d),e=1-Math.pow(1-k,3);b.textContent=Math.round(n*e);if(k<1)requestAnimationFrame(f);else b.textContent=t}
    b.textContent='0';requestAnimationFrame(f)}
})();


(function(){
  var fm=document.querySelector('.fm');if(!fm)return;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  var items=[].slice.call(fm.querySelectorAll('.fm-i')),grid=fm.querySelector('.fm-grid');
  if(!items.length||!grid||rm||!('IntersectionObserver' in window))return;
  var stopped=false,vis=false,t=null;
  function cur(){for(var i=0;i<items.length;i++)if(items[i].open)return i;return -1}
  function next(){if(stopped||!vis)return;var i=(cur()+1)%items.length;items[i].open=true}
  function start(){if(!t&&!stopped)t=setInterval(next,4200)}
  function stop(){clearInterval(t);t=null}
  /* user takes over: stop auto play for good */
  grid.addEventListener('pointerdown',function(){stopped=true;stop()},{passive:true});
  grid.addEventListener('keydown',function(){stopped=true;stop()});
  new IntersectionObserver(function(es){vis=es[0].isIntersecting;vis?start():stop()},{threshold:.35}).observe(grid);
})();

(function(){
  var nu=document.querySelector('.nu');if(!nu)return;
  var rows=[].slice.call(nu.querySelectorAll('.nu-r')),f={g:1,mg:1,mcg:.001,'\u00b5g':.001};
  function mg(r){var a=parseFloat(String(r.getAttribute('data-amt')).replace(',','.'))||0;return a*(f[(r.getAttribute('data-unit')||'mg').toLowerCase()]||1)}
  var max=Math.max.apply(null,rows.map(mg).concat([1]));
  /* sqrt scale so tiny amounts (zinc, B6) stay visible */
  rows.forEach(function(r,i){r.style.setProperty('--i',i);r.style.setProperty('--p',Math.max(.05,Math.sqrt(mg(r)/max)).toFixed(3));var g=r.getAttribute('data-g');});
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  function run(){nu.classList.add('in');if(rm)return;rows.forEach(function(r,i){var b=r.querySelector('.nu-v b'),t=b.textContent,n=parseFloat(String(r.getAttribute('data-amt')).replace(',','.'));if(isNaN(n))return;var dec=(String(r.getAttribute('data-amt')).split(/[.,]/)[1]||'').length,t0=null,d=1300,dl=i*70;
    function s(ts){if(!t0)t0=ts;var k=Math.min(1,Math.max(0,(ts-t0-dl)/d)),e=1-Math.pow(1-k,3);b.textContent=(n*e).toFixed(dec);if(k<1)requestAnimationFrame(s);else b.textContent=t}requestAnimationFrame(s)})}
  if(!('IntersectionObserver' in window)){nu.classList.add('in');return}
  var io=new IntersectionObserver(function(es){if(es[0].isIntersecting){io.disconnect();run()}},{threshold:.25});io.observe(nu);
})();

(function(){
  var w=document.querySelector('.why');if(!w)return;var els=[].slice.call(w.querySelectorAll('.rv'));
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.2});
  els.forEach(function(e){io.observe(e)});
})();

(function(){
  var b=document.querySelector('.ing-belt');if(!b)return;
  var down=false,sx=0,sl=0,moved=false;
  b.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;sx=e.clientX;sl=b.scrollLeft});
  window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>3){moved=true;b.classList.add('drag')}b.scrollLeft=sl-dx});
  window.addEventListener('pointerup',function(){down=false;b.classList.remove('drag')});
})();
/* Product page: also show a copy of the reviews right above "Our quality promise" */
(function(){
  var rev=document.querySelector('.rev'),qp=document.querySelector('.fm .qp');
  if(!rev||!qp||!qp.parentNode)return;
  var c=rev.cloneNode(true);c.removeAttribute('aria-labelledby');
  c.querySelectorAll('[id]').forEach(function(e){e.removeAttribute('id')});
  qp.parentNode.insertBefore(c,qp);
})();
